import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.USER_MANAGEMENT }) ||
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.USER_MANAGEMENT, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
